import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Inject, Optional, Provider } from '@angular/core';
import { AppInsightsConfig, provideAiConfig, AI_CONFIG } from './app-insights-config.provider';
import { AppInsightsErrorHandlerProvider } from './app-insights-error-handler.service';
import { AppInsightsRef } from './app-insights-ref';
import { AppInsightsTelemetryInitializer, provideAiTelemetryInitializers, AI_TELEM_INITIALIZERS } from './app-insights-telem-initializers.provider';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';


@NgModule({
  imports: [CommonModule],
  declarations: [],
  exports: [],
  providers: []
})
export class AppInsightsModule {
  /**
   * The constructor will initialize appInsightsRef with a new ApplicationInsights instance
   * using the config and telemetry initializers passed in forRoot.
   */
  constructor(appInsightsRef: AppInsightsRef,
    @Inject(AI_CONFIG) aiConfig: AppInsightsConfig,
    @Optional() @Inject(AI_TELEM_INITIALIZERS) aiTelemetryInitializers: AppInsightsTelemetryInitializer[] = []) {

    const config = {
      ...aiConfig,
      // if enableAutoRouteTracking isn't set, the default to true since the default is false
      enableAutoRouteTracking: (aiConfig.enableAutoRouteTracking != null) ? aiConfig.enableAutoRouteTracking : true
    };

    const appInsights = new ApplicationInsights({ config });
    appInsights.loadAppInsights();
    (aiTelemetryInitializers || []).forEach(x => appInsights.addTelemetryInitializer(x));

    // assign appInsightsRef
    appInsightsRef.appInsights = appInsights;
  }

  static forRoot(
    config: AppInsightsConfig,
    telemetryInitializers?: AppInsightsTelemetryInitializer[]
  ): ModuleWithProviders<AppInsightsModule> {
    return {
      ngModule: AppInsightsModule,
      providers: [
        AppInsightsRef,
        AppInsightsErrorHandlerProvider,
        provideAiConfig(config),
        provideAiTelemetryInitializers(telemetryInitializers ?? []),
      ]
    };
  }
}
